// extracted by mini-css-extract-plugin
export default {"wrapper":"headline__wrapper__tcs39","container":"headline__container__svENa","title":"headline__title__iN7kE","description":"headline__description__ZMAWm"};